/*
 * @Date: 2020-01-06 17:24:12
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 15:59:46
 * @FilePath: /rongxin.web/src/main.js
 */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import './style/element-variables.scss';
import App from './App.vue';
import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/_base.scss';
import message from '../utils/message.js';
import * as filter from '../utils/index.js';

// 重置 ElementUI 默认属性
ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Dialog.props.closeOnPressEscape.default = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default global options } */);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

var eventBus = new Vue();
Vue.prototype.$bus = eventBus;

// 消息提醒
Object.keys(message).forEach(key => {
  Vue.prototype['$' + key] = message[key];
});

// 过滤器
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key]);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
